import * as actionTypes from './ordersActionTypes';

const initialState = {
    TabIndex: 0,
    TransportOrdersFetchActivated: false,
    ActiveTransportOrders: [],
    CompletedTransportOrders: [],
    ActiveTransportOrdersExpandedRowIDs: []
}

export default function ordersReducer(state = initialState, action) {

    switch (action.type) {
        case (actionTypes.SET_TAB_INDEX):
            if (action.tabIndex !== state.TabIndex) {
                return Object.assign({}, state, { TabIndex: action.tabIndex });
            }
            return state

        case (actionTypes.SET_TRANSPORT_ORDERS_FETCH_ACTIVATED):
            if (action.fetchActivated !== state.TransportOrdersFetchActivated) {
                return Object.assign({}, state, { TransportOrdersFetchActivated: action.fetchActivated });
            }
            return state

        case (actionTypes.SET_ACTIVE_TRANSPORT_ORDERS):
            if (action.orders) {
                if (action.orders.Results !== state.ActiveTransportOrders) {
                    return Object.assign({}, state, { ActiveTransportOrders: action.orders.Results });

                }
            }

            return state;
        case (actionTypes.SET_COMPLETED_TRANSPORT_ORDERS):
            if (action.orders) {
                if (action.orders.Results !== state.CompletedTransportOrders) {

                    return Object.assign({}, state, { CompletedTransportOrders: action.orders.Results });

                }
            }

            return state;

        case (actionTypes.SET_ACTIVE_TRANSPORT_ORDERS_EXPANDED_ROW_IDS):
            if (action.ids !== state.ActiveTransportOrdersExpandedRowIDs) {
                return Object.assign({}, state, { ActiveTransportOrdersExpandedRowIDs: action.ids });
            }

            return state;
        default:
            return state;
    }
}


